var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCsv = function SvgCsv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#csv_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.662 46.282h32.571a.86.86 0 0 0 .857-.857V11.997h-7.714a2.575 2.575 0 0 1-2.571-2.572V1.711H13.662a.86.86 0 0 0-.857.857v42.857a.86.86 0 0 0 .857.857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m45.86 10.285-7.36-7.36v6.503a.86.86 0 0 0 .857.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M48.054 10.034 38.773.75a2.6 2.6 0 0 0-1.818-.753h-23.29a2.575 2.575 0 0 0-2.571 2.571v42.858a2.575 2.575 0 0 0 2.571 2.571h32.572a2.575 2.575 0 0 0 2.571-2.571V11.85a2.55 2.55 0 0 0-.754-1.818m-9.532-7.11 7.36 7.36H39.38a.86.86 0 0 1-.858-.857zm-24.857 43.36h32.572a.86.86 0 0 0 .857-.857V11.998h-7.715a2.575 2.575 0 0 1-2.571-2.571V1.712H13.665a.86.86 0 0 0-.857.857v42.858c0 .473.384.857.857.857",
    clipRule: "evenodd",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    fillRule: "evenodd",
    d: "M38.522 33.934h-2.297v-2.242h-.054q-1.499 2.593-4.41 2.592-2.073-.001-3.32-1.13-1.245-1.126-1.246-3.031 0-4.001 4.732-4.675l4.3-.603q-.001-3.64-2.954-3.64-2.593 0-4.677 1.749v-2.35q.63-.477 2.157-.918 1.523-.44 2.715-.442 5.054 0 5.055 5.362v9.326zm-2.297-7.255-3.47.492c-1.187.168-2.016.45-2.495.847q-.712.597-.713 1.925 0 1.08.772 1.73.769.65 1.971.651 1.711-.001 2.824-1.205 1.113-1.203 1.114-3.01v-1.43zm5.21 11.033 2.22-6.857h-2.22l-1.633 6.857z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M3.384 39.428H22.24a2.57 2.57 0 0 0 2.572-2.572V18a2.57 2.57 0 0 0-2.572-2.571H3.384a2.57 2.57 0 0 0-2.571 2.571v18.857a2.57 2.57 0 0 0 2.57 2.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    d: "m7.648 34.287 3.727-6.875-3.415-6.84h2.747l1.863 4.37q.258.623.353.93h.026q.183-.5.384-.968l1.992-4.332h2.52l-3.5 6.8 3.59 6.915H15.25l-2.151-4.8a4 4 0 0 1-.257-.643h-.031a3.3 3.3 0 0 1-.249.622l-2.216 4.82z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "csv_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.813-.002h48v48h-48z"
  })))));
};
export default SvgCsv;